import { InputAdornment, TextField } from "@mui/material";

export const Input = ({ ...props }) => (
  <TextField
    {...props}
    autoComplete="off"
    sx={{
      maxWidth: props.fullWidth ? "none" : props?.maxWidth || "102px",
      "& .MuiInputBase-root": {
        paddingRight: "0px",
      },
      "& .MuiInputBase-input": {
        paddingRight: "4px",
      },
      ...props.sx,
    }}
    size="small"
    inputProps={{
      ...props.inputProps,
      readOnly: props.readOnly,
      sx: { ...props.inputProps?.sx, textAlign: props.textAlign || "end" },
      min: 0,
    }}
    InputProps={{
      ...props.InputProps,
      endAdornment: props.unit ? (
        <InputAdornment
          position="end"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            whiteSpace: "nowrap",
            flexShrink: 0,
            padding: "0px 6px 0px 0px",
            minWidth: "auto",
          }}
        >
          {props.unit}
        </InputAdornment>
      ) : null,
    }}
  />
);

export const Text = ({ ...props }) => (
  <Input
    {...props}
    readOnly
    variant="standard"
    inputProps={{
      sx: {
        maxWidth: props?.maxWidth || "unset",
        fontWeight: 700,
        padding: 0,
      },
    }}
    InputProps={{
      readOnly: true,
      disableUnderline: true,
      sx: {
        "& .MuiInputAdornment-root > p": {
          color: "#000",
          fontWeight: 700,
          paddingRight: "14px",
        },
      },
    }}
  />
);
